import isUndefinedOrNull from "./isUndefinedOrNull";

const withQueryParams = (url, queryParams) => {
  const queryString = Object.entries(queryParams)
    .reduce((result, [key, value]) => {
      const isInvalidKey = isUndefinedOrNull(key);
      const isInvalidValue = isUndefinedOrNull(value);

      if (isInvalidKey || isInvalidValue) {
        return result;
      }

      return result.concat(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }, [])
    .join("&");

  if (queryString) {
    return `${url}?${queryString}`;
  }
  
  return url;
};

export default withQueryParams;
